import React from 'react';
import { siteConfig } from '../config/siteConfig';
export function Footer() {
  const currentYear = new Date().getFullYear(); // Use 2026 as per metadata, or dynamic
  return <footer className="w-full bg-brand-cream py-12 border-t border-gray-200" data-id="element-69">
      <div className="container mx-auto px-4 max-w-7xl flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-70">
        <p className="text-sm text-muted-foreground text-center md:text-left font-light" data-id="element-71">
          © 2026 {siteConfig.brand.name}. All rights reserved.
        </p>
        <div className="flex items-center gap-8" data-id="element-72">
          <a href={siteConfig.links.privacy} className="text-sm text-muted-foreground hover:text-brand-navy transition-colors font-light" data-id="element-73">
            Privacy Policy
          </a>
          <a href={siteConfig.links.terms} className="text-sm text-muted-foreground hover:text-brand-navy transition-colors font-light" data-id="element-74">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}